<template>
  <fullscreen-overlay-frame :title="$t('faq-dialog.title').toString()"
                            icon="contact_support"
                            color="primary"
                            centered
                            closable
                            hide-actions-slot
                            @close="abort">

    <template v-slot:content>
      <v-text-field
          v-model="searchTerm"
          :label="$t('faq-dialog.search-label')"
          prepend-inner-icon="search"
          clearable
          outlined
          dense
          class="mb-4">
        ></v-text-field>
      <v-skeleton-loader v-if="loading"
                         type="list-item" />
      <v-expansion-panels v-else-if="items.length > 0" v-model="activePanelIndex">
        <v-expansion-panel v-for="item in filteredItems" v-bind:key="item.id">
          <v-expansion-panel-header class="font-weight-bold primary--text">
            {{item.title}}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div v-html="item.body"/>
            <v-btn v-if="item.linkLabel && item.linkAddress"
                   depressed
                   color="primary"
                   class="mt-6"
                   :href="item.linkAddress"
                   target="_blank">
              {{ item.linkLabel }}
              <v-icon right>call_made</v-icon>
            </v-btn>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <div v-else
           v-html="$t('faq-dialog.empty-state')"/>
    </template>

  </fullscreen-overlay-frame>
</template>

<script>
import FullscreenOverlayFrame from "@/templates/dialogs/FullscreenOverlayFrame";
import requestHelper from "@/scripts/requestHelper";

export default {
  name: 'FaqDialog',
  props: ['data'],
  components: {
    FullscreenOverlayFrame
  },

  data: () => ({
    loading: false,
    items: [],
    searchTerm: null,
    activePanelIndex: null
  }),

  methods: {
    getData() {
      this.loading = true
      this.$rhRequest.sendGet({
        endpoint: 'content-service/get-relevant',
        params: {type: 'FAQ'}
      }, (response) => {
        if (response.data.data) {
          this.items = response.data.data
        }
        this.loading = false
      }, (error) => {
        console.error(error)
        this.loading = false
      })
    },

    abort() {
      if (this.data?.callbackDialog) {
        this.$root.bisadialog.toggle(this.data?.callbackDialog)
      }
      this.$root.bisadialog.toggle('faq')
    },
  },

  computed: {
    filteredItems() {
      if (!this.searchTerm) {
        return this.items;
      }
      const lowerSearchTerm = this.searchTerm.toLowerCase().trim();
      if (lowerSearchTerm === '') {
        return this.items;
      }
      return this.items.filter(item => {
        const titleMatch = item.title.toLowerCase().includes(lowerSearchTerm)
        const bodyMatch = item.body.toLowerCase().includes(lowerSearchTerm)
        return titleMatch || bodyMatch
      });
    }
  },

  watch: {
    filteredItems(list) {
      const isSearching = this.searchTerm && this.searchTerm.trim() !== ''
      if (isSearching && list.length > 0) {
        this.activePanelIndex = 0
      } else {
        this.activePanelIndex = null
      }
    }
  },

  mounted() {
    this.loading = true
    requestHelper.startDelayedRequest(() => this.getData())
  }
};
</script>

<style lang="scss" scoped>
.v-input__slot input {
   text-align: left;
}
</style>
